import React from "react";
import { Box, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { COLORS } from "../../assets/theme";
import { getFeatureInfo } from "./featureCatalog";

/**
 * What a locked module is and how to get it. Shared by the dialog the sidebar
 * opens and the panel a locked route renders — the copy says "not switched on",
 * never "error" and never "deleted".
 */
const FeatureLockedContent: React.FC<{ feature: string }> = ({ feature }) => {
  const info = getFeatureInfo(feature);

  return (
    <>
      <Box
        sx={{
          width: 42,
          height: 42,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: COLORS.SidebarActiveBg,
          mb: 1.5,
        }}
      >
        <LockOutlinedIcon sx={{ color: COLORS.SidebarActiveText }} />
      </Box>

      <Typography sx={{ fontWeight: 700, fontSize: "1.25rem", mb: 0.5 }}>
        {info.label}
      </Typography>
      <Typography
        sx={{ color: COLORS.placeHolderColor, fontSize: "0.92rem", mb: 2 }}
      >
        {info.tagline}
      </Typography>

      {info.includes.length > 0 && (
        <Box sx={{ mb: 2.5 }}>
          <Typography
            sx={{
              fontSize: "0.72rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: COLORS.placeHolderColor,
              mb: 1,
            }}
          >
            What's included
          </Typography>
          {info.includes.map((line) => (
            <Box
              key={line}
              sx={{ display: "flex", gap: 1, alignItems: "flex-start", mb: 0.75 }}
            >
              <CheckCircleOutlineIcon
                sx={{ fontSize: 18, color: COLORS.SUCCESS, mt: "2px" }}
              />
              <Typography sx={{ fontSize: "0.9rem" }}>{line}</Typography>
            </Box>
          ))}
        </Box>
      )}

      <Box
        sx={{
          bgcolor: COLORS.MainBackground,
          border: `1px solid ${COLORS.BorderColor}`,
          borderRadius: 2,
          p: 2,
        }}
      >
        <Typography sx={{ fontSize: "0.9rem" }}>
          This module isn't switched on for your account yet. Get in touch and
          we'll enable it — your existing data stays exactly as it is, and
          nothing needs setting up again.
        </Typography>
      </Box>
    </>
  );
};

export default FeatureLockedContent;
